(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amelia-footer-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-amp-footer-video]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let loaded = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!loaded) { video.preload = 'metadata'; video.load(); loaded = true; }
            if (video.dataset.autoplay === 'true' && !reducedMotion) {
              video.muted = true;
              video.play().catch(() => {});
            }
          } else if (loaded) { video.pause(); }
        });
      }, {rootMargin: '100px'});
      observer.observe(video);
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amelia-information"]) return;
  try {
    
(() => {
  const states = new WeakMap();
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.amelia-information summary.ap-question');
    if (!summary || event.defaultPrevented) return;
    const details = summary.parentElement;
    const answer = details.querySelector('.ap-answer');
    if (!answer || !details.animate) return;
    event.preventDefault();
    const previous = states.get(details);
    const expand = !(previous ? previous.expand : details.open);
    const start = details.getBoundingClientRect().height;
    if (previous) previous.animation.cancel();
    details.style.height = '';
    details.style.overflow = '';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      states.delete(details);
      details.open = expand;
      details.removeAttribute('data-ap-closing');
      summary.removeAttribute('aria-expanded');
      return;
    }
    details.open = true;
    const style = getComputedStyle(details);
    const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    const end = expand ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + borders;
    details.toggleAttribute('data-ap-closing', !expand);
    summary.setAttribute('aria-expanded', String(expand));
    details.style.overflow = 'hidden';
    const animation = details.animate({ height: [start + 'px', end + 'px'] }, { duration: 240, easing: 'cubic-bezier(.25,.1,.25,1)' });
    states.set(details, { animation, expand });
    animation.onfinish = () => {
      if (states.get(details)?.animation !== animation) return;
      details.open = expand;
      details.style.overflow = '';
      details.removeAttribute('data-ap-closing');
      summary.removeAttribute('aria-expanded');
      states.delete(details);
    };
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

if (!customElements.get('mobile-gallery-indicators')) {
  customElements.define('mobile-gallery-indicators', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('product-images');
      this.track = this.gallery?.querySelector('[data-product-media-list]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children).filter(el => el.matches('.product__slide:not(.amp-gallery-clone)'));
      this.buttons = Array.from(this.querySelectorAll('[data-gallery-index]'));
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-index]');
        if (button && this.contains(button)) this.go(Number(button.dataset.galleryIndex), true);
      }, options);
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : (this.current || 0) + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(next,true,event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0);
        this.buttons[this.normalize(next)]?.focus({preventScroll:true});
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        this.queueSettle();
      }, {...options, passive: true});
      this.track.addEventListener('scrollend', () => this.settle(), options);
      this.track.addEventListener('touchstart', () => {
        this.touching = true;
        clearTimeout(this.settleTimer);
      }, {...options, passive:true});
      ['touchend','touchcancel'].forEach(name => this.track.addEventListener(name, () => {
        this.touching = false;
        this.queueSettle();
      }, {...options, passive:true}));
      this.observer = new MutationObserver(() => this.followVariant());
      this.observer.observe(this.gallery, {attributes:true, attributeFilter:['data-active-media']});
      this.layout = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => {
          if (!this.mobile.matches) {
            this.removeClones();
            this.gallery.style.removeProperty('margin-left');
            this.gallery.style.removeProperty('margin-right');
            this.gallery.style.removeProperty('--mobile-gallery-height');
            return;
          }
          this.ensureClones();
          this.gallery.style.setProperty('margin-left', '0px', 'important');
          this.gallery.style.setProperty('margin-right', '0px', 'important');
          const left = this.gallery.getBoundingClientRect().left;
          this.gallery.style.setProperty('margin-left', `${-left}px`, 'important');
          this.gallery.style.setProperty('margin-right', `${left}px`, 'important');
          const width = this.gallery.getBoundingClientRect().width;
          this.gallery.style.setProperty('--mobile-gallery-height', `${width}px`);
          this.go(this.current ?? 0, false);
        });
      };
      this.resize = new ResizeObserver(this.layout);
      this.resize.observe(this.gallery);
      this.resize.observe(this.gallery.parentElement);
      window.addEventListener('resize', this.layout, {...options, passive: true});
      this.mobile.addEventListener('change', this.layout, options);
      this.layout();
      this.followVariant();
    }
    normalize(index) {
      return (index % this.slides.length + this.slides.length) % this.slides.length;
    }
    createClone(index) {
      const image = this.slides[index].querySelector('img');
      if (!image) return null;
      const clone = document.createElement('div');
      clone.className = 'product__slide amp-gallery-clone';
      clone.dataset.ampGalleryClone = String(index);
      clone.setAttribute('aria-hidden','true');
      clone.inert = true;
      const photo = document.createElement('div');
      photo.className = 'product__photo';
      const wrapper = document.createElement('div');
      wrapper.className = 'image-wrapper';
      const copy = image.cloneNode(true);
      Array.from(copy.attributes).forEach(attribute => {
        if (attribute.name === 'id' || attribute.name.startsWith('data-')) copy.removeAttribute(attribute.name);
      });
      copy.alt = '';
      copy.loading = 'eager';
      copy.fetchPriority = 'low';
      wrapper.append(copy);
      photo.append(wrapper);
      clone.append(photo);
      return clone;
    }
    ensureClones() {
      if (this.clones || this.slides.length < 2) return;
      const before = this.createClone(this.slides.length - 1);
      const after = this.createClone(0);
      if (!before || !after) return;
      this.track.prepend(before);
      this.track.append(after);
      this.clones = [before,after];
    }
    removeClones() {
      this.clones?.forEach(clone => clone.remove());
      this.clones = null;
      clearTimeout(this.settleTimer);
    }
    followVariant() {
      const index = this.slides.findIndex(slide => slide.dataset.mediaId === this.gallery.dataset.activeMedia);
      if (index >= 0) this.go(index, false);
    }
    position(slide, animate) {
      const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({left:this.track.scrollLeft + delta, behavior:animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
    }
    go(index, animate, direction = 0) {
      if (!this.mobile.matches || !this.slides.length) return;
      const logicalIndex = this.normalize(index);
      let slide = this.slides[logicalIndex];
      if (animate && this.clones) {
        if (index < 0 || direction === 0 && this.current === 0 && logicalIndex === this.slides.length - 1) slide = this.clones[0];
        else if (index >= this.slides.length || direction === 0 && this.current === this.slides.length - 1 && logicalIndex === 0) slide = this.clones[1];
      }
      this.current = logicalIndex;
      this.position(slide,animate);
      this.mark(logicalIndex);
    }
    mark(index) {
      this.buttons.forEach((button, i) => {
        button.setAttribute('aria-current', String(i === index));
        button.tabIndex = i === index ? 0 : -1;
      });
    }
    nearest() {
      const left = this.track.getBoundingClientRect().left;
      let nearest;
      let distance = Infinity;
      [...this.slides,...(this.clones || [])].forEach(slide => {
        const delta = Math.abs(slide.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; nearest = slide; }
      });
      return {slide:nearest,distance};
    }
    update() {
      if (!this.mobile.matches) return;
      const {slide} = this.nearest();
      if (!slide) return;
      const index = slide.hasAttribute('data-amp-gallery-clone') ? Number(slide.dataset.ampGalleryClone) : this.slides.indexOf(slide);
      this.current = index;
      this.mark(index);
    }
    queueSettle() {
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(),180);
    }
    settle() {
      if (!this.mobile.matches || this.touching || !this.clones) return;
      const {slide,distance} = this.nearest();
      if (!slide?.hasAttribute('data-amp-gallery-clone') || distance > 2) return;
      const index = Number(slide.dataset.ampGalleryClone);
      this.position(this.slides[index],false);
      this.current = index;
      this.mark(index);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.removeClones();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.layoutFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
